import { ReportCharge, IReportChargeRepo, ReportChargeFilter } from "../entities/charge"
import { getTenantId } from "../../common/jwt"
import axios from "../../common/axios"

export class ReportChargeRepo implements IReportChargeRepo {
    async listReportCharges(tenantId: number, params: ReportChargeFilter): Promise<ReportCharge[]> {
        const resp = await axios.get(`/v2/${getTenantId()}/report-charges`, { params })
        return resp.data
    }
}